
@custom-media --mobile (max-width: 768px);

.container {
  padding-top: 2em;
}

.listing {
  font-weight: bold;
  font-size: 0.8em;
  margin-bottom: 4em;

  @media (--mobile) {
    margin-bottom: 2em;
  }
}
